import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Navbar from "../components/navigation/Navbar";
import BottomNav from "../components/navigation/BottomNav";
import Profile from "../components/auth/Profile";
import { Tabs } from "../components/ui/Tabs";
import { colors } from "../utils/colors";

interface DashboardProps {
  token?: string;
}

export default function Dashboard(props: DashboardProps): React.JSX.Element {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [accessToken, setAccessToken] = useState<string | null>(null);

  useEffect(() => {
    const handleRedirectCallback = async () => {
      if (isAuthenticated) {
        try {
          const token = await getAccessTokenSilently();
          setAccessToken(token);
          localStorage.setItem("accessToken", token);
        } catch (error) {
          console.error("Error getting access token:", error);
        }
      }
    };

    handleRedirectCallback();
  }, [isAuthenticated, getAccessTokenSilently]);

  return (
    <div style={{ backgroundColor: colors.background, minHeight: "100vh" }}>
      <div className="view">
        <Navbar token={accessToken} />
      </div>
      <Profile />
      <Tabs token={accessToken || undefined} />
      <BottomNav />
    </div>
  );
}
